/* eslint-disable camelcase */
import i18next from 'i18next'

import {initReactI18next} from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {supportedLanguages} from '@constants'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    lng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: Object.keys(supportedLanguages.raw),
    fallbackLng: 'en',
    parseMissingKeyHandler: key => {
      return key
    },
  })

export default i18next
